import { Component } from '@angular/core';

@Component({
	templateUrl: './emptydemo.component.html',
})
export class EmptyDemoComponent {}
